import { render, staticRenderFns } from "./WidgetCropRatio.vue?vue&type=template&id=517fd30a&scoped=true&"
import script from "./WidgetCropRatio.vue?vue&type=script&lang=js&"
export * from "./WidgetCropRatio.vue?vue&type=script&lang=js&"
import style0 from "./WidgetCropRatio.vue?vue&type=style&index=0&id=517fd30a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517fd30a",
  null
  
)

export default component.exports